function initEtReveal() {
  var els = document.querySelectorAll('.et-reveal, .et-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('et-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('et-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initEtFaq() {
  var items = document.querySelectorAll('.et-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var trigger = item.querySelector('.et-faq-question');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('et-faq-open');
      items.forEach(function (other) { other.classList.remove('et-faq-open'); });
      if (!isOpen) item.classList.add('et-faq-open');
    });
  });
}

function initEtCounters() {
  var counters = document.querySelectorAll('.et-counter');
  if (!counters.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.dataset.target || '0');
        var decimals = (el.dataset.target || '').split('.')[1] ? (el.dataset.target.split('.')[1] || '').length : 0;
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toFixed(decimals);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  counters.forEach(function (el) { observer.observe(el); });
}

function initEtLineupTilt() {
  var cards = document.querySelectorAll('.et-lineup-card');
  if (!cards.length || window.matchMedia('(pointer: coarse)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}

function initEtParallax() {
  var media = document.querySelector('.et-hero-media img');
  if (!media) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(max-width: 749px)').matches) return;

  var ticking = false;
  function update() {
    var rect = media.parentElement.getBoundingClientRect();
    var progress = 1 - (rect.top + rect.height) / (window.innerHeight + rect.height);
    var offset = (progress - 0.5) * 60;
    media.style.transform = 'translateY(' + offset.toFixed(1) + 'px) scale(1.12)';
    ticking = false;
  }
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );
  update();
}

function initEtProductGallery() {
  var gallery = document.querySelector('.et-product-gallery');
  if (!gallery) return;
  var main = gallery.querySelector('.et-product-gallery-main img');
  var thumbs = gallery.querySelectorAll('.et-product-thumb');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var fullSrc = thumb.dataset.full;
      if (!fullSrc) return;
      main.src = fullSrc;
      main.alt = thumb.dataset.alt || main.alt;
      thumbs.forEach(function (t) { t.classList.remove('et-product-thumb-active'); });
      thumb.classList.add('et-product-thumb-active');
    });
  });
}

function initEtVariantPicker() {
  var form = document.querySelector('.et-buy-form');
  if (!form) return;
  var variantsData = form.querySelector('[data-et-variants]');
  if (!variantsData) return;
  var variants;
  try {
    variants = JSON.parse(variantsData.textContent);
  } catch (e) {
    return;
  }
  var optionInputs = form.querySelectorAll('[data-et-option]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('.et-buy-price');
  var compareEl = document.querySelector('.et-buy-compare-price');
  var addBtn = form.querySelector('.et-buy-add');

  function currentSelection() {
    var selected = [];
    optionInputs.forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) selected.push(checked.value);
    });
    return selected;
  }

  function findVariant(selected) {
    return variants.find(function (v) {
      return v.options.length === selected.length && v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: window.etCurrency || 'EUR' });
  }

  function updateUI() {
    var selected = currentSelection();
    var match = findVariant(selected);
    if (!match) return;
    idInput.value = match.id;
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      if (match.available) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.dataset.addText || 'Add to cart';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.soldOutText || 'Sold out';
      }
    }
  }

  optionInputs.forEach(function (group) {
    group.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('change', updateUI);
    });
  });

  updateUI();
}

document.addEventListener('DOMContentLoaded', function () {
  initEtReveal();
  initEtFaq();
  initEtCounters();
  initEtLineupTilt();
  initEtParallax();
  initEtProductGallery();
  initEtVariantPicker();
});
